import createCachedSelector from 're-reselect';
import scheduleFacilityViewStateSelector from 'store/selectors/scheduleSelectors/scheduleFacilityViewStateSelector';
import { IGlobalReduxStore } from 'store';

const activePositionTabSelector = createCachedSelector(
  scheduleFacilityViewStateSelector,
  (facilityViewState) => facilityViewState.activeTab,
)((state: IGlobalReduxStore) => {
  const facilityViewState = scheduleFacilityViewStateSelector(state);

  const activeTab = facilityViewState.activeTab;

  return activeTab;
});

export default activePositionTabSelector;
